import { DrayageCargoDetailsState } from "freight/types/DrayageCargoDetailsTypes";

export const drayageCargoDetailsInitialState: DrayageCargoDetailsState = {
  packingListDocumentKey: null,
  packingListFileName: null,
};
